"use strict";

var _slicedToArray = require("c:\\Users\\tdmam\\Documents\\Projects\\key-hints\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

function useBoolean(initial) {
  var _react_1$useState = react_1.useState(initial),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      value = _react_1$useState2[0],
      setValue = _react_1$useState2[1];

  var toggle = react_1.useCallback(function () {
    return setValue(function (v) {
      return !v;
    });
  }, []);
  var setTrue = react_1.useCallback(function () {
    return setValue(true);
  }, []);
  var setFalse = react_1.useCallback(function () {
    return setValue(false);
  }, []);
  var actions = react_1.useMemo(function () {
    return {
      setValue: setValue,
      toggle: toggle,
      setTrue: setTrue,
      setFalse: setFalse
    };
  }, [setFalse, setTrue, toggle]);
  return react_1.useMemo(function () {
    return [value, actions];
  }, [actions, value]);
}

exports.useBoolean = useBoolean;
exports.default = useBoolean;